import Phaser from 'phaser'
import { getLocale, type Locale, LOCALES, setLocale, t } from '../../i18n'
import { mountSettingsOverlay, type SettingsOverlayHandle } from '../../ui/JKGame_settingsOverlay'
import { audio } from '../JKGame_audio'
import { COLORS } from '../JKGame_ui'

export class JKGame_SettingsScene extends Phaser.Scene {
  private overlay?: SettingsOverlayHandle
  private noteTimer?: Phaser.Time.TimerEvent
  private readonly keyEsc = (): void => {
    this.scene.start('Menu')
  }
  private readonly keyNumber = (event: KeyboardEvent): void => {
    const n = Number.parseInt(event.key, 10)
    if (n >= 1 && n <= LOCALES.length) this.pickLocale(LOCALES[n - 1].id)
  }

  constructor() {
    super('Settings')
  }

  create(): void {
    this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
      this.noteTimer?.remove()
      this.noteTimer = undefined
      this.overlay?.destroy()
      this.overlay = undefined
      this.input.keyboard?.off('keydown-ESC', this.keyEsc)
      this.input.keyboard?.off('keydown', this.keyNumber)
    })
    this.input.keyboard?.off('keydown-ESC', this.keyEsc).on('keydown-ESC', this.keyEsc)
    this.input.keyboard?.off('keydown', this.keyNumber).on('keydown', this.keyNumber)
    this.cameras.main.setBackgroundColor(COLORS.bg)
    this.cameras.main.fadeIn(240, 0, 0, 0)

    const soundOn = !audio.isMuted()
    this.overlay = mountSettingsOverlay({
      title: t('settings.title'),
      pitch: t('settings.pitch'),
      languageTitle: t('settings.language'),
      audioTitle: t('settings.audio'),
      backLabel: t('menu.back'),
      locales: LOCALES.map((locale) => ({
        id: locale.id,
        label: locale.label,
        selected: locale.id === getLocale(),
      })),
      audioLabel: this.audioLabel(soundOn),
      audioOn: soundOn,
      onLocale: (locale) => {
        audio.play('uiTap')
        this.pickLocale(locale)
      },
      onAudio: () => {
        audio.play('uiTap')
        const muted = audio.toggleMuted()
        this.overlay?.setAudio(this.audioLabel(!muted), !muted)
      },
      onBack: () => {
        audio.play('uiBack')
        this.scene.start('Menu')
      },
    })
  }

  private audioLabel(on: boolean): string {
    return `${t('settings.audio')}：${on ? t('settings.soundOn') : t('settings.soundOff')}`
  }

  private pickLocale(locale: Locale): void {
    if (locale === getLocale()) {
      this.showCurrentHint()
      return
    }
    setLocale(locale)
    this.scene.restart()
  }

  private showCurrentHint(): void {
    this.noteTimer?.remove()
    this.overlay?.setNote(t('settings.current'))
    this.noteTimer = this.time.delayedCall(1800, () => {
      this.overlay?.setNote('')
      this.noteTimer = undefined
    })
  }
}
